
import {from as observableFrom,  of ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx/src/data-persistence';
import { map ,  switchMap ,  mapTo } from 'rxjs/operators';

import { toDashedFromCamelCase } from '../../../../../helpers/';
import { GITLAB_COMMIT_PL } from '../../../../constants/';
import { GetCompleteAction, NoopAction, UndoAction } from '../../../../ngrx/actions/root.action';
import { AppState, getEmptyESState } from '../../../../ngrx/state/';
import { jsonApiToEntityState } from '../../../../shared/services/app/web-socket/http-response';
import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import * as gitlabCommit from './gitlab-commit.actions';
import { Features } from '../../../../libs/paywall/features.constants';
import { PaywallService } from '../../../../libs/paywall/paywall.service';

@Injectable()
export class GitlabCommitEffects {
  private key = toDashedFromCamelCase(GITLAB_COMMIT_PL);

  readonly defaultErrorHandler = (action, error) => {
    console.error('effect', action, error);
  };

  @Effect()
  getByTask$ = this._paywall.isFeatureEnabled(Features.Gitlab)
    ? this.data.fetch(gitlabCommit.GET_TASK_COMMIT, {
        run: (action: gitlabCommit.GetTaskCommit, store) =>
          this.api.get([this.key], action.payload).pipe(
            map(jsonApiToEntityState),
            switchMap(state => {
              const actions = [
                new GetCompleteAction(state),
                new gitlabCommit.GetTaskCommitComplete({
                  taskId: action.payload.task,
                  entities: state[GITLAB_COMMIT_PL] || getEmptyESState()
                })
              ];
              return of(...actions);
            })
          ),
        onError: (action, error) => {
          this.defaultErrorHandler(action, error);
          return new gitlabCommit.GetTaskCommitFail();
        }
      })
    : observableFrom([]);

  @Effect()
  remove$ = this._paywall.isFeatureEnabled(Features.Gitlab)
    ? this.data.optimisticUpdate(gitlabCommit.DELETE_TASK_COMMIT, {
        run: (action: gitlabCommit.DeleteTaskCommit, store) =>
          this.api.deleteRequest([this.key, action.payload.id]).pipe(mapTo(new NoopAction())),
        undoAction: (action, error) => {
          this.defaultErrorHandler(action, error);
          return new UndoAction(action);
        }
      })
    : observableFrom([]);

  constructor(
    private api: AtlazApiV2Service,
    private data: DataPersistence<AppState>,
    private _paywall: PaywallService
  ) {}
}
